import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseEntity from "./BaseEntity";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";
import {getJenisKelamin, getPenerimaDana} from "../util/PluralVariabels";

@inheritSerialization(BaseEntity)
export default class NamaItemPembayaran extends BaseEntity {

    @serialize
    @deserialize
    public nama: string = "";

    @serialize
    @deserialize
    public keterangan: string = "";

    @serialize
    @deserialize
    public penerima: string = "";

    @serialize
    @deserialize
    public jenis_kelamin: string = "";

    @serialize
    @deserialize
    public nomor_rekening: string = "";

    @serialize
    @deserialize
    public nama_rekening: string = "";

    public penerimaFeedback() {
        return this.defaultPropertyFeedback('penerima');
    }

    public jenisKelaminFeedback() {
        return this.defaultPropertyFeedback('jenis_kelamin');
    }

    public namaRekeningFeedback() {
        return this.defaultPropertyFeedback('nama_rekening');
    }

    public nomorRekeningFeedback() {
        return this.defaultPropertyFeedback('nomor_rekening');
    }

    public table() {
        const {nama, penerima:pen, jenis_kelamin: kel, nomor_rekening, nama_rekening} = this;
        const jenis_kelamin = getJenisKelamin(kel);
        const penerima = getPenerimaDana(pen);
        return {nama, penerima, jenis_kelamin, nomor_rekening, nama_rekening};
    }

    public file: any = null;

    public fileFeedback() {
        return this.defaultPropertyFeedback('file', Boolean(this.file));
    }

    public namaFeedback() {
        return this.defaultPropertyFeedback('nama');
    }

    public static columnName(): Array<TableColumn> {
        const table = new NamaItemPembayaran().table();
        let keys = Object.keys(table);

        return keys.map((field: any, index: number) => {
            const tableColumn = new TableColumn();
            tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

            if (index > 1) {
                tableColumn.position = 'centered';
            }

            return tableColumn;
        });
    }

}
